import React from 'react';
import _ from 'lodash';
import {
  WiFiButton, VersionButton, Title,
  OneImgInFull,
  OneImgWithGap,
  OneImgWithIntro,
  RightImgWithIntro,
  BannerImg,
  Movie,
  MovieContainer,
  Text,
  Container,
  Image,
  Button,
  FAQ,
  Rule,
  Coupon,
  RegForm,
  CouponContainer,
  VideoItem,
  DrawContainer,
  ActivityRule,
  Prize,
  PrizeRecord,
  Share,
  MovieCouponContainer,
  CouponMovie,
  DiscountCard,HotelRankList
} from '@/components';
import {pxToVW} from './pxToVW';
const componentsMap = {
  'Text': Text,
  'Image': Image,
  'Button': Button,
  'Container': Container,
  'BannerImg': BannerImg,
  'Title': Title,
  'WiFiButton': WiFiButton,
  'VersionButton': VersionButton,
  'OneImgInFull': OneImgInFull,
  'OneImgWithGap': OneImgWithGap,
  'OneImgWithIntro': OneImgWithIntro,
  'RightImgWithIntro': RightImgWithIntro,
  'Movie': Movie,
  'MovieContainer': MovieContainer,
  'FAQ': FAQ,
  'Rule': Rule,
  'Coupon': Coupon,
  'RegForm': RegForm,
  'CouponContainer':CouponContainer,
  'VideoItem': VideoItem,
  'DrawContainer': DrawContainer,
  'ActivityRule': ActivityRule,
  'Prize': Prize,
  'PrizeRecord': PrizeRecord,
  'Share': Share,
  'MovieCouponContainer': MovieCouponContainer,
  'CouponMovie': CouponMovie,
  'DiscountCard': DiscountCard,
  'HotelRankList':HotelRankList
}

export function getChildren(components) {

  let childrenComponent;
  if(components !== undefined) {
    childrenComponent = components.map((component, index) => {
    const Child = getChildren(component.children)
    const Children = componentsMap[component.name];
    const style = component.props.style && pxToVW(component.props.style);
    const newProps = {
      ...component.props,
      style: _.isEmpty(style) ? undefined : style
    }
    return Children && (
      <Children key={index} {...newProps}>{Child}</Children>
    )
  });
}
  return childrenComponent;
}
export function getComponents(config, handleChangePage, params) {
  const Components = config.map(componentConig => {
    const { name, children, props = {}, id, track } = componentConig;
    const childrenConig = props.children || children
    const style = props.style && pxToVW(props.style);
    const Component = componentsMap[name];
    const newProps = {
      ...props,
      ...params,
      handleChangePage:(router,data)=>handleChangePage(router,data),
      children: childrenConig && !_.isEmpty(childrenConig) && getComponents(childrenConig, handleChangePage, params),
      style: _.isEmpty(style) ? undefined : style
    }
    return Component && (
      <Component
      track={track}
      key={id}
      id={id}
      {...newProps} />);
  });

  return Components;
}

export function isBlockEnv() {
  return !(window.location.host === 'static.ccrgt.com' || window.location.host === 't-static.ccrgt.com') ;
}

export function eventMap(props) {
  const {  href, target, cid, vid, nativePage, nativePath, externalUrl, router, handleChangePage, event, shareInfo, modalInfo, qaChannel, } = props;
  let params = {}
  switch(event) {
    case 'openUrl': return params = (!_.isNil(href) && !_.isNil(target))? { url: href, target }: {};
    case 'openView': return params = (!_.isNil(cid) && !_.isNil(vid)) ? { cid, vid }: {};
    case 'openNativeView': return params =  { nativePage, nativePath, externalUrl };
    case 'shareAndGrantCoupon': return params =  {shareInfo,modalInfo};
    case 'openAudio': return params = !_.isNil(cid) ? { cid } : {};
    case 'openVideoChannel': return params =  { nativePath };
    case 'openReader': return  params =  { nativePath };
    case 'showShareMenu': return params = {shareInfo};
    case 'awakeApp': return  params =  { nativePage };
    case 'openQuickApp': return params = {qaChannel, href, nativePath};
    default: return params;
  }
}


export const businessType = {
  1: 'netCar',
  8801: 'phoneRecharge',
};
